import React from 'react';
import { FormItem } from '..';

const types = { 1: '本人', 2: '家族', 3: '家主', 4: '管理会社', 5: 'その他' };
const validations = ['matchType'];
class RelationshipType extends FormItem {
  /* eslint-disable no-magic-numbers */
  static types = types;
  static isPrincipal = (typeCode) => typeCode && String(typeCode) === '1';
  static isOther = (typeCode) => typeCode && String(typeCode) !== '1';
  /* eslint-enable no-magic-numbers */
  constructor (props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
  }
  getTypes () {
    return types;
  }
  isPrincipal () {
    const self = this;
    return RelationshipType.isPrincipal(self.getVal());
  }
  isOther () {
    const self = this;
    return RelationshipType.isOther(self.getVal());
  }
  renderReadonly () {
    const self = this;
    const relationshipTypes = RelationshipType.types;
    return <p className="mb-0">{relationshipTypes[self.getVal()] || ''}</p>;
  }
  renderInput () {
    const self = this;
    const relationshipTypes = RelationshipType.types;
    return (
      <div>
        <div className="row">
          <div className="col-sm-4">ご使用者:</div>
          <div className="col-sm-8">
            {Object.keys(relationshipTypes)
              .filter((v) => String(v) === '1')
              .map((v, i) => {
                const t = relationshipTypes[v];
                return (
                  <div key={`rel-radio-${i}`} className="d-block d-sm-inline-block">
                    <label key={`rel-radio-${i}`} className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name={self.props.name}
                        value={v}
                        checked={String(self.getVal()) === String(v)}
                        onChange={() => {
                          self.setVal(String(v));
                        }}
                      />
                      <div className="custom-control-label">{t}</div>
                    </label>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4 text-nowrap">ご使用者とのご関係:</div>
          <div className="col-sm-8">
            {Object.keys(relationshipTypes)
              .filter((v) => String(v) !== '1')
              .map((v, i) => {
                const t = relationshipTypes[v];
                return (
                  <div key={`rel-radio-${i}`} className="d-block d-sm-inline-block">
                    <label className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name={self.props.name}
                        value={v}
                        checked={String(self.getVal()) === String(v)}
                        onChange={() => {
                          self.setVal(String(v));
                        }}
                      />
                      <div className="custom-control-label">{t}</div>
                    </label>
                  </div>
                );
              })}
          </div>
        </div>
        {self.renderValError()}
      </div>
    );
  }
}
export default RelationshipType;
